/**
 * /tracking/universal-tag — operator page for feature #161.
 *
 * Declares a TanStack Router route and renders the `UniversalTagPage`
 * feature. The root wire-up picks this up from `router.tsx`.
 *
 * No search params — the page manages its own selected-tag state
 * internally (list-detail pattern in the same card).
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { UniversalTagPage } from "@/features/universal-tag/UniversalTagPage";

export const trackingUniversalTagRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/universal-tag",
	component: TrackingUniversalTagRoute,
});

export default trackingUniversalTagRoute;

export function TrackingUniversalTagRoute() {
	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-5xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">Universal tag</li>
				</ol>
			</nav>

			<UniversalTagPage />
		</div>
	);
}

// Named export for the root wire-up cycle.
export { TrackingUniversalTagRoute as TrackingUniversalTagPage };
